import React from "react";

function SquareAnim() {
  return (
    <div className=" opacity-0 sm:opacity-100 animate-spin animation-duration-5000 sm:w-[30px] sm:h-[30px] w-[20px] h-[20px]  border-firstColor border-2 sm:border-4 absolute right-10 bottom-1/4 "></div>
  );
}

export default SquareAnim;
